import md5 from "blueimp-md5"
import { createRouter, createWebHistory } from "vue-router"

import { getPage } from "@/composables/get-page"
import { recordScroll } from "@/composables/use-page-ready"

import { KirbyPageData } from "@/queries"

import Default from "../views/Default.vue"
import Student from "../views/Student.vue"
import Home from "../views/Home.vue"
import Programme from "@/views/Programme.vue"
import { PathUtils } from "@/utils/path.utils.js"

export const useRouter = (site: any) => {
  if (!site) {
    return createRouter({
      history: createWebHistory(import.meta.env.BASE_URL),
      routes: [
        {
          path: "/",
          component: Default,
        },
      ],
    })
  }

  const capitalize = (string: string) =>
    string.charAt(0).toUpperCase() + string.slice(1)

  // published pages routes

  const routes = [
    ...site.children.map((page: KirbyPageData) => ({
      path: "/" + page.uri,
      name: page.template,
      component: () =>
        import(`../views/${capitalize(page.template)}.vue`).catch(
          () => Default,
        ),
    })),
    // ...site.children
    //   .filter((page: KirbyPageData) => page.childTemplate)
    //   .map((page: KirbyPageData) => ({
    //     path: "/" + page.uri + "/:id",
    //     name: page.childTemplate,
    //     component: () =>
    //       import(`../views/${capitalize(page.childTemplate)}.vue`).catch(
    //         () => Default,
    //       ),
    //   })),
  ]

  // home route / instead of /home
  routes.find(route => route.path === "/home").path = "/"
  routes.find(route => route.path === "/").component = Home

  routes.push({ path: "/home", redirect: "/" })
  routes.push({ path: "/programmes/:id", component: Programme })
  routes.push({ path: "/programmes/:programme/:id", component: Student })
  routes.push({ path: "/students/:id", component: Student })
  routes.push({
    path: "/stretcher",
    component: () => import("../views/Stretcher.vue"),
  })

  // catch all fallback
  routes.push({ path: "/:pathMatch(.*)*", component: Default })

  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(_to, _from, savedPosition) {
      // Don't scroll now — record the target and let setReady() apply it once the
      // incoming view's awaits resolve. Back/forward restores the saved position;
      // forward navigation falls back to the top (handled in recordScroll).
      recordScroll(savedPosition)
      return false
    },
  })

  const isHideSite = import.meta.env.VITE_HIDE_SITE

  router.beforeEach(async (to, from, next) => {
    const apiQuery = from.query?.api
    if (apiQuery) to.query.api = apiQuery

    if (isHideSite === "false") {
      next()
      return
    }

    // if (to.path.includes("/students/")) {
    //   next()
    //   return
    // }

    if (to.path !== "/") {
      const previewQuery = to.query?.preview

      if (!previewQuery) next({ path: "/home" })
      else {
        const page = await getPage<KirbyPageData>({
          query: `page("${PathUtils.strip(to.path)}")`,
          select: {
            uri: true,
          },
        })

        const hash = md5(page.uri)
        if (hash !== previewQuery) next({ path: "/home" })

        next()
        return
      }
    } else {
      next()
      return
    }
  })

  return router
}
